export default [
    {
        path: '/customer',
        props: true,
        component: () => import('@/views/Customer'),
    },
    {
        path: '/customer/:id',
        props: true,
        component: () => import('@/views/Customer/Show.vue'),
        meta: {
            activates: '/customer',
        }
    },
    {
        path: '/customer/traveller/:id',
        props: true,
        component: () => import('@/views/Customer/Traveller/Show'),
    },
];
